// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Ezra Design Tokens — Single Source of Truth
 *
 * All visual tokens live here. Consumed by:
 *   - tailwind.config.js (via CSS variable references)
 *   - Components (via Tailwind classes or var(--token))
 *
 * DO NOT hardcode hex colors in component files.
 * Use Tailwind classes (bg-brand-primary, text-status-success, etc.)
 * or CSS variables (var(--color-brand-primary)) instead.
 */

:root {
  /* ─── Brand ─── */
  --color-brand-primary: #7CB342;   /* green — actions, links, primary CTA */
  --color-brand-accent: #689F38;    /* darker green — interactive hover states */

  /* ─── Status (green is ONLY for positive status) ─── */
  --color-status-success: #16A34A;
  --color-status-warning: #D97706;
  --color-status-danger:  #DC2626;
  --color-status-neutral: #6B7280;
  --color-status-info:    #2563EB;

  /* ─── Surface ─── */
  --color-surface-sidebar: #F8F9FB; /* off-white, barely visible */
  --color-surface-header:  #FFFFFF;
  --color-surface-content: #F3F4F6; /* page background */
  --color-surface-card:    #FFFFFF;

  /* ─── Border ─── */
  --color-border-subtle:  #E5E7EB;
  --color-border-default: #D1D5DB;

  /* ─── Text ─── */
  --color-text-primary:   #111827;
  --color-text-secondary: #6B7280;
  --color-text-muted:     #9CA3AF;
  --color-text-inverse:   #FFFFFF;

  /* ─── Layout ─── */
  --space-sidebar-width: 220px;
  --space-header-height: 56px;

  /* ─── Chart palette (for Recharts / data viz) ─── */
  --color-chart-blue:    #2563EB;
  --color-chart-green:   #16A34A;
  --color-chart-amber:   #D97706;
  --color-chart-red:     #DC2626;
  --color-chart-purple:  #7C3AED;
  --color-chart-pink:    #DB2777;
  --color-chart-orange:  #EA580C;

  /* ─── Shadows ─── */
  --shadow-card:     0 1px 3px rgba(0, 0, 0, 0.08);
  --shadow-dropdown: 0 4px 12px rgba(0, 0, 0, 0.12);
  --shadow-modal:    0 8px 24px rgba(0, 0, 0, 0.16);

  /* ─── Overlay ─── */
  --color-overlay: rgba(0, 0, 0, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/styles/tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;EACE,kBAAkB;EAClB,8BAA8B,IAAI,wCAAwC;EAC1E,6BAA6B,KAAK,4CAA4C;;EAE9E,uDAAuD;EACvD,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,oBAAoB;EACpB,gCAAgC,EAAE,8BAA8B;EAChE,gCAAgC;EAChC,gCAAgC,EAAE,oBAAoB;EACtD,gCAAgC;;EAEhC,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;;EAE/B,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;;EAE3B,oDAAoD;EACpD,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,oBAAoB;EACpB,gDAAgD;EAChD,iDAAiD;EACjD,iDAAiD;;EAEjD,oBAAoB;EACpB,mCAAmC;AACrC","sourcesContent":["/*\n * Ezra Design Tokens — Single Source of Truth\n *\n * All visual tokens live here. Consumed by:\n *   - tailwind.config.js (via CSS variable references)\n *   - Components (via Tailwind classes or var(--token))\n *\n * DO NOT hardcode hex colors in component files.\n * Use Tailwind classes (bg-brand-primary, text-status-success, etc.)\n * or CSS variables (var(--color-brand-primary)) instead.\n */\n\n:root {\n  /* ─── Brand ─── */\n  --color-brand-primary: #7CB342;   /* green — actions, links, primary CTA */\n  --color-brand-accent: #689F38;    /* darker green — interactive hover states */\n\n  /* ─── Status (green is ONLY for positive status) ─── */\n  --color-status-success: #16A34A;\n  --color-status-warning: #D97706;\n  --color-status-danger:  #DC2626;\n  --color-status-neutral: #6B7280;\n  --color-status-info:    #2563EB;\n\n  /* ─── Surface ─── */\n  --color-surface-sidebar: #F8F9FB; /* off-white, barely visible */\n  --color-surface-header:  #FFFFFF;\n  --color-surface-content: #F3F4F6; /* page background */\n  --color-surface-card:    #FFFFFF;\n\n  /* ─── Border ─── */\n  --color-border-subtle:  #E5E7EB;\n  --color-border-default: #D1D5DB;\n\n  /* ─── Text ─── */\n  --color-text-primary:   #111827;\n  --color-text-secondary: #6B7280;\n  --color-text-muted:     #9CA3AF;\n  --color-text-inverse:   #FFFFFF;\n\n  /* ─── Layout ─── */\n  --space-sidebar-width: 220px;\n  --space-header-height: 56px;\n\n  /* ─── Chart palette (for Recharts / data viz) ─── */\n  --color-chart-blue:    #2563EB;\n  --color-chart-green:   #16A34A;\n  --color-chart-amber:   #D97706;\n  --color-chart-red:     #DC2626;\n  --color-chart-purple:  #7C3AED;\n  --color-chart-pink:    #DB2777;\n  --color-chart-orange:  #EA580C;\n\n  /* ─── Shadows ─── */\n  --shadow-card:     0 1px 3px rgba(0, 0, 0, 0.08);\n  --shadow-dropdown: 0 4px 12px rgba(0, 0, 0, 0.12);\n  --shadow-modal:    0 8px 24px rgba(0, 0, 0, 0.16);\n\n  /* ─── Overlay ─── */\n  --color-overlay: rgba(0, 0, 0, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
